import { customElement } from 'aurelia-framework';

@customElement('as-form-skeleton')
export class FormSkeleton {
  getRandomWidth() {
    return Math.floor(Math.random() * 75);
  }
}
